import { render, staticRenderFns } from "./UnidadeMedidaLista.vue?vue&type=template&id=3959cc9c&lang=html&"
import script from "./UnidadeMedidaLista.vue?vue&type=script&lang=js&"
export * from "./UnidadeMedidaLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/unidade-medida/UnidadeMedidaLista.vue
// module id = 1607
// module chunks = 28